import { type BillingCustomer, type Plan } from '../../models/Plan'
import { ASSISTANT_PRODUCT, billingOptionFor } from './seatUnitPrice'

export const ASSISTANT_SEATS_NOT_OFFERED = 'Assistant seats are not included in your plan.'
export const ASSISTANT_SEATS_UPGRADE = 'to invite an Administrative Assistant.'

export const offersAssistantSeats = (customer?: BillingCustomer, plan?: Plan): boolean => {
  if (plan?.additionalProducts.some((product) => product.type === ASSISTANT_PRODUCT)) {
    return true
  }
  const period = customer?.subscription?.period
  if (!customer || !period) {
    return false
  }
  return !!billingOptionFor(customer, period)?.additionalProducts.some((product) => product.type === ASSISTANT_PRODUCT)
}
